import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { MoreHorizontal, Trash2, Edit } from "lucide-react";

export const createColumns = (onDeleteClick, onEditClick = null) => [
  {
    accessorKey: "id",
    header: "ID",
    cell: ({ row }) => <div className="font-mono text-xs">{row.id}</div>,
  },
  {
    accessorKey: "email",
    header: "Email",
    cell: ({ row }) => (
      <div className="max-w-xs truncate" title={row.email}>
        {row.email}
      </div>
    ),
  },
  {
    accessorKey: "role",
    header: "Role",
    cell: ({ row }) => (
      <div className="text-sm text-gray-500 capitalize">
        {row.role === "user" ? "Guest" : "Admin"}
      </div>
    ),
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => (
      <div className="text-sm text-gray-500">
        {row.created_at ? new Date(row.created_at).toLocaleDateString() : ""}
      </div>
    ),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => (
      <div className="text-sm text-gray-500">
        {row.updated_at ? new Date(row.updated_at).toLocaleDateString() : ""}
      </div>
    ),
  },
  {
    accessorKey: "actions",
    header: "Actions",
    cell: ({ row }) => (
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0" size="sm">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-40">
          <div className="flex flex-col space-y-1">
            {onEditClick && (
              <Button
                variant="ghost"
                size="sm"
                className="justify-start"
                onClick={() => onEditClick(row)}
              >
                <Edit className="mr-2 h-4 w-4" />
                Edit
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              className="justify-start text-red-600 hover:text-red-700"
              onClick={() => onDeleteClick(row)}
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Delete
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    ),
    enableSorting: false,
  },
];
